export default {
  QuotationCustomerLang: {
    code: 'Product Code',
    Level: 'Quotation Level',
    Quotation: 'Standard Quotation',
    VIP: 'VIP Quotation',
    LogisticsProduct: 'Logistics Product',
    Status: 'Status',
    Disabled: 'Disabled',
    Enabled: 'Enabled',
    EffectiveTime: 'Effective Time',

    Supplier: 'Supplier Quotation ID',
    Discount: 'Additional Charge Rate',
    QuotationMethod: 'Quotation Method',
    Standard: 'Standard',
    Channel: 'Channel',
    ChannelQuotationID: 'Channel Quotation ID',
    Exist: 'Channel Quotation ID Does Not Exist',
    Currency: 'Currency',
    SourceCurrency: 'Source Currency',
    TargetCurrency: 'Target Currency',
    ExchangeRate: 'Exchange Rate',
    StartDate: 'Start Date',
    EndDate: 'End Date',
    CreatedBy: 'Created By',
    LogisticsProductCode: 'Logistics Product Code',

    customerCode: 'Customer ID',
    customerName: 'Customer Abbreviation',
    salesmanName: 'Company Sales Rep',
    bindCustomer: 'Bind Customer',
    bind: 'Batch Bind',
    unbind: 'Batch Unbind',
    all: 'All',
    bound: 'Bound',
    unbound: 'Unbound',
    Carrier: 'Carrier',
    EffectiveDateRange: 'Effective Date Range',
    AddRate: 'Add Rate',
    BatchEnable: 'Batch Enable',
    BatchDisable: 'Batch Disable',
    ImportTemplate: 'Import Template',
    Import: 'Import',
    ImportFile: 'File Import',
    Export: 'Export',
    Operation: 'Operation',
    RateNo: 'Rate No.',
    SurchargeRatePercent: 'Surcharge Rate',
    StartTime: 'Start Time',
    EndTime: 'End Time',
    FuelSurchargeRate: 'Fuel Surcharge Rate',
    FuelSurchargeRateAdd: 'Add Fuel Surcharge Rate',
    FuelSurchargeRateEdit: 'Edit Fuel Surcharge Rate',
    RateNoPlaceholder: 'Auto generated by system',
    PleaseSelectCarrier: 'Please select carrier',
    PleaseSelectStatus: 'Please select status',
    Remarks: 'Remarks',
    RemarksPlaceholder: 'Please enter remarks...',
    ApiNotConfigured: 'API not configured',
    ImportApiNotConfigured: 'Import API not configured',
    FuelSurchargeRateFileName: 'Fuel Surcharge Rate.csv',
  }
};
